// extracted by mini-css-extract-plugin
export default {"elementPlaceholder":"elementPlaceholder-guracJE0","caption":"caption-RBIg2L4G"};